/**
 * TileMapLayer registration: parser and property formatter.
 */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseTileMapLayer } from './parser';
import { formatTileMapLayerProperties } from './propertyFormatter';
const tileMapLayerRegistration = {
    typeName: 'TileMapLayer',
    parser: parseTileMapLayer,
    propertyFormatter: formatTileMapLayerProperties,
};
nodeRegistry.register(tileMapLayerRegistration);
//# sourceMappingURL=index.js.map